import React         from "react";
import Grid          from '@mui/material/Grid';

import Header        from '../../components/header';
import Story         from './molecules/story';
import Ad            from '../../components/ad';
import Footer        from '../../components/footer';
import '../../app.min.css';

class ViewBlog extends React.Component {
	constructor (props) {
		super (props);
		this.state = {
			value : 0,
		};
	}

	componentDidMount () {
		document.title = "Blog View | Overseas.one";
	}

	render (props) {
		return (
			<div className="container">
				<Header />
				<Grid container spacing={2}>
					<Grid item xs={0} md={2}>
					</Grid>
					<Grid item xs={12} md={6}>
						<Story />
					</Grid>
					<Grid item xs={12} md={2}>
						<Ad
							dataAdSlot={"6801895925"}
						/>
					</Grid>
				</Grid>
				<Footer />
			</div>
		);
	}
}

export default ViewBlog;
